import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=38e6542f&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=38e6542f&lang=scss&scoped=true"
import style1 from "./Notification.vue?vue&type=style&index=1&id=38e6542f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6542f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e6542f')) {
      api.createRecord('38e6542f', component.options)
    } else {
      api.reload('38e6542f', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=38e6542f&scoped=true", function () {
      api.rerender('38e6542f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification/Notification.vue"
export default component.exports